// TOOLTIP
//

// Access Patch : see : https://codepen.io/kimdobie/pen/mGQWqJ

var fn_tooltip_init = function () {

    /* Manually determine when an item should show and hide a tool tip. */
    $('[data-toggle="tooltip"]')
        .attr("tabindex", 0)
        .tooltip({ trigger: "manual", animation: true, delay: {show: 100, hide: 140} })
        .mouseover(event => {
            $(event.target).tooltip("show");
            $(".tooltip").on("mouseleave", function () {
                setTimeout(() => {
                    $(event.target).tooltip("hide");
                }, 140);
            });
        })
        .mouseout(event => {
            setTimeout(() => {
                if (!$(".tooltip:hover").length) $(event.target).tooltip("hide");
            }, 140);
        })
        .focus(event => {
            $(event.target).tooltip("show");
        })
        .blur(event => {
            setTimeout(() => {
                $(event.target).tooltip("hide");
            }, 140);
        });

    /* Listen for the "escape key" so tool tips can easily be hidden */
    $("body").keydown(event => {
        if (event.keyCode === 27) {
            $('[data-toggle="tooltip"]').tooltip("hide");
        }
    });

};
